import { render, staticRenderFns } from "./table-3.vue?vue&type=template&id=244d8b7f&scoped=true"
import script from "./table-3.vue?vue&type=script&lang=js"
export * from "./table-3.vue?vue&type=script&lang=js"
import style0 from "./table-3.vue?vue&type=style&index=0&id=244d8b7f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244d8b7f",
  null
  
)

export default component.exports